import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API } from '../api/axios';
import { useAuth } from './AuthContext';

function ApplyRouteGuard({ children }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    const checkApplicationStatus = async () => {
      if (!user) {
        navigate('/signin');
        return;
      }
      if (user?.applied) {
        navigate('/my-application'); // or wherever
      } else {
        setLoading(false); // Allow render
      }
    };
    user && checkApplicationStatus();
  }, [navigate, user]);

  if (loading) return null; // or show a spinner

  return children;
}
export default ApplyRouteGuard;
